<template>
  <div v-editable="blok" class="video-wrapper" :style="[videoStyle]">
    <iframe :src="src" frameBorder="0" loading="lazy" :allow="allow" />
  </div>
</template>

<script lang="ts" setup>
import type { SbIframeVideoStoryblok } from '@/types'

interface Props {
  blok: SbIframeVideoStoryblok
}
const props = defineProps<Props>()

const src = ref('')
const allow = ref()
const checkFullscreen = () => {
  src.value = props.blok.allow_full_screen
    ? `${props.blok.link}?playsinline=1`
    : props.blok.link
  allow.value = props.blok.allow_full_screen ? 'fullscreen' : null
}
checkFullscreen()
const videoStyle = computed(() => {
  return {
    paddingBottom: `${props.blok.video_ratio || 56.25}%`,
  }
})
</script>

<style lang="scss" scoped>
.video-wrapper {
  position: relative;
  overflow: hidden;
  transform: translateZ(0);
  width: 100%;
  border-radius: 18px;

  @media (min-width: $breakpoint-md) {
    border-radius: 24px;
  }
}

iframe {
  transform: scale(1.005);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
